import { styled } from "@mui/material/styles";

export const IconWrap = styled("div")`
  display: flex;
  align-items: center;
`;

export const ScoreWrap = styled("div")`
  margin-left: 6px;
  max-width: 60px;
  align-items: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const PointsTag = styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
`;
